export const WELLNESS_CHECK_IN_SCORES = [  
  {
    key: 'energyLevel',
    label: 'Energy Levels',
    emoji: '⚡',
    prompt: 'How energised do you feel right now?',
    anchors: [
      { range: '1–4', label: 'Drained,', description: 'drained, heavy' },
      { range: '5–7', label: 'Moderate', description: 'okay, functional' },
      { range: '8–10', label: 'High Energy', description: 'energised, focused' },
    ],
  },
  {
    key: 'stressLevel',
    label: 'Calm Levels',
    emoji: '😌',
    prompt: 'How calm and settled do you feel right now?',
    anchors: [
      { range: '1–4', label: 'Stressed', description: 'stressed, restless' },
      { range: '5–7', label: 'Manageable', description: 'tense but manageable' },
      { range: '8–10', label: 'Calm', description: 'calm, grounded' },
    ],
  },
  {
    key: 'emotionalState',
    label: 'Emotional State',
    emoji: '💜',
    prompt: 'How emotionally resourced do you feel?',
    anchors: [
      { range: '1–4', label: 'Overwhelmed', description: 'overwhelmed, irritable' },
      { range: '5–7', label: 'Neutral', description: 'neutral' },
      { range: '8–10', label: 'Open', description: 'open, steady' },
    ],
  },
  {
    key: 'physicalState',
    label: 'Physical State',
    emoji: '💪',
    prompt: 'How does your body feel right now?',
    anchors: [
      { range: '1–4', label: 'Tense', description: 'tense, fatigued' },
      { range: '5–7', label: 'Okay', description: 'okay, some tightness' },
      { range: '8–10', label: 'At Ease', description: 'light, at ease' },
    ],
  },
]
